import useInitBroadcast from 'modules/overlay-v2/ui/hooks/initializers/use-init-broadcast';
import useInitDataOverlayV2 from 'modules/overlay-v2/ui/hooks/initializers/use-init-data-overlay-v2';
import useInitSubscribeOverlayV2 from 'modules/overlay-v2/ui/hooks/initializers/use-init-subscribe-overlay-v2';

function useInitOverlay() {
  useInitBroadcast();
  useInitDataOverlayV2();
  useInitSubscribeOverlayV2();
}

export default useInitOverlay;
